export enum NewbornPostpartumPhysicalExamTypes {
  Head = "head",
  Eyes = "eyes",
  Ears = "ears",
  NoseAndMouth = "nose-and-mouth",
  Neck = "neck",
  ChestAndAbdomen = "chest-and-abdomen",
  HipsAndExtremities = "hips-and-extremities",
  BackAndSpine = "back-and-spine",
}
